import { numberWithCommas, MethodList, GetParamsData, GetStorage, SetStorage } from '$Deposits/lib/LibCommonData'
import moment from 'moment'
import { moneyReg, moneyRegDeposit, CCNumberReg, CCPINReg, OldBankSixNumReg, } from "$Deposits/lib/Reg";
import { PayApiPort } from '../../Api'
import {
    GetMethodsActive,
    GetDepositTimeSelect,
    GetDepositDateSelect,
    GetDepositPayments,
    GetUploadFileList,
    GetDepositMoneyStatus,
    GetDepositBankActive,
    GetMenber,
    GetMethodCodeActive,
    // GetMethodsDetails,
    // GetDepositBankActive,
    GetDepositMemberBanksActive,
    // GetDepositPayments,
    // GetDepositMoneyStatus,
} from './DepositUpdate'
//获取存款方式
export const GetMethods = (activeMethods = '指定methods') => {

    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        toastTip.loading('กำลังโหลด…')
        dispatch(RemoveAllReducers())
        dispatch(SetDepositSuccessPage())
        dispatch(GetMemberInfo())//获取个人信息

        return ApiGet(`${PayApiPort.Methods}transactionType=Deposit&`)
            .then((res) => {
                toastTip.hide()
                let result = res && res.result || { paymentMethods: [] }
                if (res && res.isSuccess && result.paymentMethods) {
                    let paymentMethods = []
                    result.paymentMethods.forEach((item) => {
                        if (MethodList.includes(item.code || '')) {                   // 如果 item.code 是 'QD', 'CTC', 'LB' 就移動到最後
                            // if (['CTC',].includes(item.code) || (['LB',].includes(item.code) && window?.useCentralPayment)) { 
                            //     paymentMethods.push(item); // 先暫存，後面再處理
                            // } else {
                            //     paymentMethods.unshift(item); // 其他的往前插
                            // }
                            paymentMethods.push(item)
                        }
                    })
                    result.paymentMethods = paymentMethods
                    const active = paymentMethods.find((v) => { return v.code == activeMethods }) || false
                    
                    let codes = active
                    if (!codes) {
                        // 找到第一個不需要跳過的 paymentMethod
                        codes = paymentMethods.find(method => {
                            return !(['CTC'].includes(method.code) 
                                || (['LB'].includes(method.code) && window?.useCentralPayment))
                        }) || paymentMethods[0] // 如果都需要跳過，就使用第一個
                    }
                    codes && dispatch(SetMethodsActive(codes));//设定当前存款方式
                }
                dispatch(GetDepositMemberBanks())//获取个人银行信息
                const action = { type: 'METHODS', data: result }
                return dispatch(action)
            })
            .catch((error) => {
                toastTip.error('error...', 2)
                const action = { type: 'METHODS', data: { paymentMethods: [] } }
                return dispatch(action)
            });
    };
}

//设置当前存款方式
export const SetMethodsActive = (data) => {
    const {webPiwikEvent, webPiwikUrl, appPiwikEvent, device} = GetParamsData();
    let methodsActive = data
    const methodCode = methodsActive.availableMethods && methodsActive.availableMethods[0] && methodsActive.availableMethods[0].methodCode || 'DEFAULT'
    return (dispatch, getState) => {
        const {DepositTriggerFrom = {}} = getState();
        const {from, vendor} = DepositTriggerFrom;
        if(from === "inGame"){
            webPiwikEvent(`In${vendor.productCode}`, `Switch to ${data.code}`, `In${vendor.productCode}_C_${data.code}`);
        }
        if(from === "deposit"){
            webPiwikEvent("Deposit", `Switch to ${data.code}`, `Deposit_C_${data.code}`);
            webPiwikUrl(`deposit_${data.code.toLocaleLowerCase()}`, `${data.code} Deposit Page`)
        }
        if (device === 'APP') {
            appPiwikEvent({
                category: from === "inGame" ? `${vendor?.piwikName}` : 'Deposit',
                action: from === "inGame" ? `Switch to ${data?.code}` : `Switch to ${data?.code}`,
                name: from === "inGame" ? `${vendor?.piwikName}_C_${data?.code}` : `Deposit_C_${data?.code}`,
                path: from === "inGame" ? `${vendor?.piwikName}`.toLocaleLowerCase() : 'deposit',
                title: from === "inGame" ? `${vendor?.piwikName}` : 'Deposit',
            })
        }
        const action = {
            type: 'METHODS_ACTIVE',
            data: { methods: data.code, ...data },
        };
        dispatch(action);
        dispatch(GetMethodsDetails(methodsActive.code, methodCode));//获取存款详情
        dispatch(SetMethodCodeActive(methodCode));//设置渠道
        return
    }

}
export const RemoveMethodsActive = () => {
    return (dispatch, getState) => {
        const action = {
            type: 'METHODS_ACTIVE',
            data: {},
        };
        return dispatch(action);
    }

}
//支付渠道，默认是第一个availableMethods
export const SetMethodCodeActive = (data = 'DEFAULT', methods = '') => {
    return (dispatch, getState) => {
        if (methods) {
            //有methods表示切换渠道，要重新call api拿details
            dispatch(GetMethodsDetails(methods, data));//获取存款详情
            SetStorage('methodCode', data)
        }
        const {MethodsActive} = getState();
        if(MethodsActive.code==="LB"){
            const {webPiwikEvent, webPiwikUrl} = GetParamsData();
            webPiwikEvent("Deposit", "Switch Method", `Deposit_LB_C_${data}`)
            webPiwikUrl(`deposit_${MethodsActive.code.toLocaleLowerCase()}_${data.toLocaleLowerCase()}`, `${MethodsActive.code} ${data} Deposit Page`)
        }
        if(MethodsActive.code==="CTC"){
            const {webPiwikEvent} = GetParamsData();
            webPiwikEvent("Deposit", `Switch to ${data.slice(0,1).toUpperCase()+data.slice(1).toLowerCase()} Flow`, `Deposit_CTC_C_${data.slice(0,1).toUpperCase()+data.slice(1).toLowerCase()} flow`)
        }

        const action = {
            type: 'METHOD_CODE_ACTIVE',
            data: data,
        };
        return dispatch(action);
    }
}

export const SetDepositMisc = (typeOfKey, data) => {
    return (dispatch, getState) => {
        // const state = getState();
        const action = {
            type: typeOfKey,
            data: data,
        }
        return dispatch(action);
    }
}

//获取存款详情{LB: {...}, PPB: {...}}
const BbanksBankAccounts = { LB: 'bankAccounts', BC: 'banks', EZP: 'banks', QD: 'bankAccounts', BQR: 'bankAccounts', CTC: 'banks', RD: 'bankAccounts' }

export const GetMethodsDetails = (methods = 'LB', methodCode = 'DEFAULT') => {
    return (dispatch, getState) => {
        if (methods == 'LINE') {
            const action = { type: 'METHODS_DETAILS', data: {} }
            return dispatch(action)
        }

        const { toastTip, ApiGet, device } = GetParamsData()

        if(device && device.toLowerCase() === "web") {
            dispatch(SetDepositSuccessPage(false));
        } else {
            dispatch(RemoveAllReducers()); // 切换存款方式清空已填写数据
        }

        toastTip.loading('กำลังโหลด…')
        dispatch(SetBanksBankAccounts([{
            dummy: 'dummy'
        }]))
        let dataList;
        return ApiGet(`${PayApiPort.DetailsDeposit}transactionType=Deposit&method=${methods}&methodCode=${methodCode}&`)
            .then((res) => {
                toastTip.hide()
                //设置methods为key，
                dataList = { bankAccounts: '', banks: '', setting: '', transferTypes: '', payoutDurations: '', suggestedAmounts: '' }
                if (res) {
                    dataList = res.result || {}
                }
                let bankList = res.result[BbanksBankAccounts[methods] || 'bankAccounts'] || []
                bankList = bankList.map((item) => {
                    const { bankCode, id } = item
                    const bankId = bankCode || id || 'bankId'
                    //自定义bankId，用于web的bank选择
                    return {...item, ...{bankId}}
                })
                if(methods == 'RD') {
                    dispatch(GetDepositMemberBanks())//获取个人银行信息
                }
                dispatch(SetBanksBankAccounts(bankList))//设置bank数据(banks/bankAccounts)
                let activeBank = bankList[0] || {}
                if(dataList.setting?.isAutoAssign && (methods == 'LB')) {
                    //LB 需要使用isAutoAssign， isAutoAssign = true 时候不显示公司收款银行
                    activeBank = { isAutoAssign: true }
                }
                dispatch(SetDepositBankActive(activeBank))//默认选择第一个
                const action = { type: 'METHODS_DETAILS', data: dataList }
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.error('error...', 2)
                //设置methods为key，
                dispatch(SetBanksBankAccounts([]))
                let dataList = { bankAccounts: '', banks: '', setting: '', transferTypes: '', payoutDurations: '', suggestedAmounts: '' }
                const action = { type: 'METHODS_DETAILS', data: dataList }
                return dispatch(action)
            });
    };
}
export const GetSuggestedAmounts = (methods = 'LB', methodCode = 'DEFAULT', bankCode = 'ZING') => {
    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(`${PayApiPort.SuggestedAmounts}amount=2&method=${methods}&methodCode=${methodCode}&bankCode=${bankCode}&`)
            .then((res) => {
                let dataList = []
                if (res.isSuccess) {
                    dataList = res.result || []
                }
                const action = { type: 'SUGGESTED_AMOUNTS', data: dataList }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'SUGGESTED_AMOUNTS', data: [] }
                return dispatch(action)
            });
    };
}

//存款银行数据bankAccounts/banks
export const SetBanksBankAccounts = (data) => {
    const action = {
        type: 'BANKS_BANKACCOUNTS',
        data: data,
    };
    return action;
}

//银行搜索
export const SetDepositBankSearch = (key,) => {
    const action = {
        type: 'DEPOSIT_BANK_SEARCH',
        data: key,
    };
    return action;
}

//选中的存款银行
export const SetDepositBankActive = (data = {}) => {
    return (dispatch, getState) => {
        const { webPiwikEvent} = GetParamsData()
        const {MethodsActive, MethodCodeActive} = getState();
        if(MethodsActive.code==="CTC" && MethodCodeActive==="CHANNEL"){
            webPiwikEvent(`Deposit`, `Switch to ${data.code}`, `Deposit_Channelflow_C_${data.code}`)
        }
        const action = {
            type: 'DEPOSIT_BANK_ACTIVE',
            data: data,
        };
        return dispatch(action);
    }
}

//存款金额判断
export const SetDepositMoneyStatus = (data = '', MethodsDetails = {}, isRefresh = false) => {
    if (isRefresh) {
        const moneyStatus = { money: '', moneyErrMsg: '' }
        const action = {
            type: 'DEPOSIT_MONEY_STATUS',
            data: moneyStatus,
        };
        return action;
    }
    const { methods } = GetMethodsActive()
    const { minBal, maxBal } = MethodsDetails.setting || {}
    const wholeNumberMethods = ['BC', 'EZP', 'TMW', 'CC'];
    const isWholeNumberMethod = wholeNumberMethods.includes(methods);

    let money = '';
    if (data) {
        if (isWholeNumberMethod) {
            // For BC, EZP, TMW: Remove all non-digit characters and decimal point
            money = data.toString().replace(/[^\d]/g, '');
        } else {
            money = data.toString().replace(/[^\d.]/g, '')
                        .replace(/\./, 'x')  // Replace first dot with 'x'
                        .replace(/\./g, '')  // Remove any other dots
                        .replace('x', '.')   // Put back the first dot
                        .replace(/(\.\d{2})\d+$/, '$1');  // Limit to 2 decimal places
        }
    }

    // If it's a whole number method and there's a decimal point, remove everything after it
    if (isWholeNumberMethod && money.includes('.')) {
        money = money.split('.')[0];
    }
    let moneyErrMsg = ''
    if (money == '' || money == 0) {
        moneyErrMsg = 'กรุณากรอกจำนวนเงินฝาก'
    } else if (!moneyRegDeposit.test(money)) {
        moneyErrMsg = 'กรุณากรอกจำนวนเงินฝาก'
    } else if (Number(money) > maxBal) {
        moneyErrMsg = 'จำนวนเงินต้องไม่สูงกว่า ' + numberWithCommas(maxBal) + ' บาท'
    } else if (Number(money) < minBal) {
        moneyErrMsg = 'จำนวนเงินต้องไม่น้อยกว่า ' + numberWithCommas(minBal) + ' บาท'
    }

    const moneyStatus = { money, moneyErrMsg }
    const action = {
        type: 'DEPOSIT_MONEY_STATUS',
        data: moneyStatus,
    };
    return action;
}
//旧账户后6位数
export const SetDepositOldBankSixNumberStatus = (tempData = '', isRefresh = false) => {
    const data = tempData && tempData.toString().replace(/[^\d]/g, '') || ''
    if (isRefresh) {
        const codeStatus = { numCode: '', codeErrMsg: '' }
        const action = {
            type: 'DEPOSIT_OLD_BANK_SIX_NUMBER_STATUS',
            data: codeStatus,
        };
        return action;
    }
    let codeErrMsg = ''
    if (data == '') {
        codeErrMsg = 'โปรดกรอกหมายเลขบัญชีเก่า 6 หลักสุดท้าย'
    } else if (!OldBankSixNumReg.test(data)) {
        codeErrMsg = 'หมายเลขบัญชีธนาคารเดิมต้องไม่ต่ำกว่า 6 หลัก'
    }

    const action = {
        type: 'DEPOSIT_OLD_BANK_SIX_NUMBER_STATUS',
        data: { numCode: data, codeErrMsg },
    };
    return action;
}
//获取用户银行卡
export const GetDepositMemberBanks = (accountNumber = '') => {

    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        const { methods } = GetMethodsActive()
        return ApiGet(PayApiPort.MemberBanks + 'accountType=Deposit&')
            .then((res) => {
                let bankList = []
                if (res && res.isSuccess) {
                    bankList = res.result || []
                }
                if(accountNumber) {
                    //RD绑定新增银行号码
                    const newBank = bankList.find((v) => { return v.accountNumber == accountNumber}) || false
                    newBank && dispatch(SetReverseBankDefault(newBank.code))
                }
                //选中isDefault，没有默认第一个
                let isDefault = bankList.find((v) => { return v.isDefault == true }) || bankList[0] || {}
                if(methods == 'RD') {
                    //RD默认使用 isReverseDeposit
                    isDefault = bankList.find((v) => { return v.isReverseDeposit == true }) || bankList[0] || {}
                }
                dispatch(SetDepositMemberBanksActive(isDefault))
                const action = { type: 'DEPOSIT_MEMBER_BANKS', data: bankList }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'DEPOSIT_MEMBER_BANKS', data: [] }
                return dispatch(action)
            });
    };
}

//选中的存款银行
export const SetDepositMemberBanksActive = (data = {}) => {
    const action = {
        type: 'DEPOSIT_MEMBER_BANKS_ACTIVE',
        data: data,
    };
    return action;
}
//RD选中银行后提交
export const SetReverseBankDefault = (data = '') => {
    return (dispatch, getState) => {
        if(!data) {
            const action = { type: 'REVERSEBANKDEFAULT', data: {} }
            return dispatch(action)
        }

        const { toastTip, ApiPost } = GetParamsData()
        toastTip.loading('กำลังโหลด…')

        return ApiPost(PayApiPort.PostBindReverseDepositAccount + 'bankId=' + data + '&')
            .then((res) => {
                toastTip.hide()
                if(res.isSuccess) {
                    //绑定成功
                    toastTip.success('บันทึกสำเร็จ', 2) //保存成功
                }
                dispatch(GetDepositMemberBanks())
                const action = { type: 'REVERSEBANKDEFAULT', data: res }
                return dispatch(action)
            })
            .catch((error) => {
                toastTip.error('error...', 2)
                const action = { type: 'REVERSEBANKDEFAULT', data: {} }
                return dispatch(action)
            });
    };

}
//存款日期选择
export const SetDepositDateSelect = (data = '') => {
    const action = {
        type: 'DEPOSIT_DATE_SELECT',
        data: data,
    };
    return action;
}
//存款时间选择
export const SetDepositTimeSelect = (data = '') => {
    const action = {
        type: 'DEPOSIT_TIME_SELECT',
        data: data,
    };
    return action;
}
export const SetDepositNextStep = (data = false) => {
    const action = {
        type: 'DEPOSIT_NEXT_STEP',
        data: data,
    };
    return action;
}
export const SetDepositTimer = (data = '') => {
    return (dispatch) => {
        const action = {
            type: 'DEPOSIT_TIMER',
            data: data,
        };
        return dispatch(action);
    }
}
//上传图片list
export const SetUploadFileList = (data = {}, deletes = false) => {
    //添加
    const { fileName, fileBytes, fileSize, error = '' } = data || {}
    const lastIndex = fileName && fileName.lastIndexOf('.') || -1
    const fileType = ['JPG', 'JPEG', 'PNG']
    let errMsg = ''
    let UploadFileList = {}

    if(error) {
        errMsg = 'ไม่สามารถใช้คุณสมบัติการถ่ายภาพได้โปรดเปิดการอนุญาตการถ่ายภาพ'
    } else if (!fileBytes || !fileName) {
        errMsg = `รองรับเฉพาะไฟล์ jpg และ png และขนาดไฟล์ต้อง ไม่เกิน 4MB`
    } else if (fileSize > 1024 * 1024 * 4) {
        errMsg = `รองรับเฉพาะไฟล์ jpg และ png และขนาดไฟล์ต้อง ไม่เกิน 4MB`
    } else if (!fileType.includes(fileName.substr(lastIndex + 1).toUpperCase())) {
        errMsg = `รองรับเฉพาะไฟล์ jpg และ png และขนาดไฟล์ต้อง ไม่เกิน 4MB`
    }
    UploadFileList = { fileName: fileName || '', fileBytes: errMsg == '' ? fileBytes : '' }
    return (dispatch, getState) => {
        dispatch(SetUploadFileErr(errMsg));//错误提示
        const action = {
            type: 'UPLOAD_FILE_LIST',
            data: UploadFileList,
        };
        return dispatch(action);
    }
}
//清除全部图片
export const RemoveUploadFile = () => {
    const action = {
        type: 'UPLOAD_FILE_LIST',
        data: [],
    };
    return action;
}
//上传图片错误
export const SetUploadFileErr = (data = '') => {
    const action = {
        type: 'UPLOAD_FILE_ERR',
        data: data,
    };
    return action;
}

export const PostConfirmStep = (data = {}) => {
    const { accountNumber = '' } = data.returnedBankDetails || {}
    const transactionId = data.transactionId || ''
    const { fileName, fileBytes } = GetUploadFileList() || {}

    const postData = {
        "depositingBankAcctNum": accountNumber && accountNumber.slice(-6) || '',
        "offlineDepositDate": `${GetDepositDateSelect()} ${moment().format('HH:mm')}`,
        "fileName": fileName || '',
        "fileByte": fileBytes || '',
        'hasQR': false,
    }
    return (dispatch, getState) => {
        const { toastTip, ApiPost } = GetParamsData()
        toastTip.loading('กำลังโหลด…')
        return ApiPost(PayApiPort.ConfirmStep + 'transactionId=' + transactionId + '&', postData)
            .then((res) => {
                toastTip.hide()
                if (res.isSuccess) {
                    if(fileBytes)
                        toastTip.success("อัปโหลดสลิปแล้ว", 3)  //單據已上傳
                    dispatch(SetDepositSuccessPage(true));//成功
                } else {
                    toastTip.error('การฝากเงินล้มเหลว')
                }
                const action = {
                    type: 'POST_UPLOAD_FILE',
                    data: res,
                };
                return dispatch(action)

            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error('การฝากเงินล้มเหลว')
                const action = {
                    type: 'POST_UPLOAD_FILE',
                    data: {},
                };
                return dispatch(action)
            });
    };

}
//清除存款数据
export const ClearDepositPayments = (data = {}) => {
    const action = {
        type: 'CLEAR_DEPOSIT_PAYMENTS',
        data: data,
    };
    return action;
}
//显示成功页面
export const SetDepositSuccessPage = (data = false) => {
    return (dispatch, getState) => {
        dispatch(SetDepositNextStep());
        dispatch(SetDepositOldBank())
        if (!data) {
            //关闭成功页面清除存款数据
            dispatch(RemoveAllReducers());
        }
        const action = {
            type: 'DEPOSIT_SUCCESS_PAGE',
            data: data,
        };
        return dispatch(action);
    }

}
//CC卡号
export const SetDepositCardNumber_CC = (number = '', isRefresh = false) => {
    if (isRefresh) {
        const status = { number: '', numberErrMsg: '' }
        const action = {
            type: 'DEPOSIT_CARD_NUMBER_CC',
            data: status,
        };
        return action;
    }
    
    let numberErrMsg = ''
    const numericNumber = number.replace(/\D/g, ''); // Remove non-numeric characters
    
    if (numericNumber === '') {
        numberErrMsg = 'กรุณากรอก S/N'
    } else if (!CCNumberReg.test(numericNumber)) {
        numberErrMsg = 'หมายเลข S/N ต้องมี 16 หลัก'
    }
    
    const status = { number: numericNumber, numberErrMsg }
    const action = {
        type: 'DEPOSIT_CARD_NUMBER_CC',
        data: status,
    };
    return action;
}
//CC卡密码
export const SetDepositCardPIN_CC = (PIN = '', isRefresh = false) => {

    if (isRefresh) {
        const status = { PIN: '', PINErrMsg: '' }
        const action = {
            type: 'DEPOSIT_CARD_PIN_CC',
            data: status,
        };
        return action;
    }

    let PINErrMsg = ''
    const numericPIN = PIN.replace(/\D/g, ''); // Remove non-numeric characters
    
    if (numericPIN === '') {
        PINErrMsg = 'กรุณากรอก PIN'
    } else if (!CCPINReg.test(numericPIN)) {
        PINErrMsg = 'หมายเลข PIN ต้องมี 10 หลัก'
    }
    
    const status = { PIN: numericPIN, PINErrMsg }
    const action = {
        type: 'DEPOSIT_CARD_PIN_CC',
        data: status,
    };
    return action;
}

//取消存款
export const PostMemberCancelDeposit = (LB = false) => {
    const { transactionId } = GetDepositPayments() || {}

    // LB 流程
    if (LB) {
        return (dispatch, getState) => {
            const { toastTip, ApiPost } = GetParamsData()
            toastTip.loading('กำลังโหลด…')
            return ApiPost(PayApiPort.MemberCancelDeposit + `transactionId=${transactionId || ''}&`,)
                .then((res) => {
                    if (res?.isSuccess) {
                        toastTip.hide()
                        dispatch(SetDepositTimer(''));
                        dispatch(SetDepositNextStep());
                        dispatch(SetDepositMoneyStatus('', '', true));
                        const action = {
                            type: 'MEMBER_CANCEL_DEPOSIT',
                            data: res,
                        };
                        return dispatch(action)
                    }
                    else {
                        toastTip.hide()
                        toastTip.error(res?.result?.message)
                        const action = {
                            type: 'MEMBER_CANCEL_DEPOSIT',
                            data: {},
                        };
                        return dispatch(action)
                    }
                })
                .catch((error) => {
                    toastTip.hide()
                    toastTip.error(error?.result?.message)
                    const action = {
                        type: 'MEMBER_CANCEL_DEPOSIT',
                        data: {},
                    };
                    return dispatch(action)
                });
        };
    }
    // 非 LB 流程
    else {
        return (dispatch, getState) => {
            dispatch(SetDepositNextStep());
            const { toastTip, ApiPost } = GetParamsData()
            return ApiPost(PayApiPort.MemberCancelDeposit + `transactionId=${transactionId || ''}&`,)
                .then((res) => {
                    const action = {
                        type: 'MEMBER_CANCEL_DEPOSIT',
                        data: res,
                    };
                    return dispatch(action)

                })
                .catch((error) => {
                    const action = {
                        type: 'MEMBER_CANCEL_DEPOSIT',
                        data: {},
                    };
                    return dispatch(action)
                });
        };
    }
}
//旧账户存款
export const SetDepositOldBank = (data = false) => {
    return (dispatch, getState) => {
        const { webPiwikEvent, webPiwikUrl, appPiwikEvent, device} = GetParamsData()
        const {MethodCodeActive, DepositOldBank} =  getState();
        if (device === 'APP') {
            if (data) {
                const { methods } = GetMethodsActive()
                appPiwikEvent({
                    category: 'Deposit',
                    action: 'Toggle to Old Bank',
                    name: `Deposit_${methods}_C_Old_Bank`,
                    path: `deposit_${methods?.toLocaleLowerCase()}`,
                    title: `${methods} Deposit Page`
                })
            }
        }
        if(data){
            webPiwikEvent("Deposit", "Toggle to Old Bank", `Deposit_LB_${MethodCodeActive}_C_Old_Bank`)
            webPiwikUrl("deposit_old_bank", "Old Bank Deposit Page")
        }else if(DepositOldBank && !data){
            webPiwikUrl(`deposit_${MethodCodeActive.toLocaleLowerCase()}`, `${MethodCodeActive} Dopisit Page`)
        }
        const action = {
            type: 'DEPOSIT_OLD_BANK',
            data: data,
        };
        return dispatch(action);
    }

}

export const SetCopyKey = (data = '') => {
    return (dispatch, getState) => {
        const action = {
            type: 'COPY_KEY',
            data: data,
        };
        return dispatch(action);
    }
}

export const SetDepositAccountByAmount = (data) => {
    return (dispatch) => {
        const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: data }
        return dispatch(action)
    }
}
//判断LB是否可以存款
export const GetDepositAccountByAmount = (remove = false) => {


    return (dispatch, getState) => {
        if(remove) {
            const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: {} }
            return dispatch(action)
        }
        const { toastTip, ApiGet } = GetParamsData()
        const { enBankName, isAutoAssign = false } = GetDepositBankActive()
        const { money } = GetDepositMoneyStatus()
        const { methods } = GetMethodsActive()
        const { memberCode } = GetMenber()
        const methodCode = GetMethodCodeActive() || 'DEFAULT'


        let params = isAutoAssign 
            ? `amount=${money}&paymentMethod=LB&paymentMethodCode=${methodCode}&` 
            : `depositingBankName=${enBankName}&amount=${money}&paymentMethod=LB&paymentMethodCode=${methodCode}&`

        toastTip.loading('กำลังโหลด…')
        return ApiGet(PayApiPort.DepositAccountByAmount + params)
            .then((res) => {
                toastTip.hide()
                let datas = ''
                if(res.isSuccess) {
                    datas = res.result
                }
                const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: datas }
                const { webPiwikEvent, webPiwikUrl, appPiwikEvent, device } = GetParamsData();

                if (device === 'APP') {
                    const { methods = '', name = '' } = GetMethodsActive() || {}
                    const { DepositTriggerFrom = {} } = getState();
                    const { from, vendor = {} } = DepositTriggerFrom;
                    let vendorPiwikName = 'In' + vendor?.piwikName || ''
                    let data = {
                        category: from === "inGame" ? vendorPiwikName : 'Deposit',
                        action: from === "inGame" ? `Submit Deposit` : `Submit Deposit Local Bank`,
                        name: from === "inGame" ? `${vendorPiwikName}_S_${methods}_Deposit` : `Deposit_LB_S_Deposit`,
                        path: from === "inGame" ? vendorPiwikName?.toLocaleLowerCase() : `deposit_local_bank`,
                        title: from === "inGame" ? vendorPiwikName : `Local Bank Deposit Page`,
                        isSuccess: res.isSuccess ? 2 : 1
                    }

                    if (from === "inGame") {
                    } else {
                        data.customProperties = {
                            [`Deposit_LB_S_Deposit_Amount`]: money
                        }
                    }

                    if (!res.isSuccess) {
                        if (from === "inGame") {
                            data.customProperties = {
                                [`${vendorPiwikName}_S_${methods}_Deposit_ErrorMsg`]: ''
                            }
                        } else {
                            data.customProperties = {
                                [`Deposit_LB_S_Deposit_ErrorMsg`]: '',
                            }
                        }
                    }
                    appPiwikEvent(data)
                }
                // dispatch(SetDepositNextStep(true))
                return dispatch(action)
            })
            .catch((error) => {
                toastTip.hide()
                const action = { type: 'DEPOSIT_ACCOUNT_BY_AMOUNT', data: {} }
                toastTip.error("failed to get DepositAccountByAmount")
                return dispatch(action)
            });
    };
}

//添加 LB step 2 access record
export const InsertMemberDepositStepTwoAccessRecord = (data={}) => {


    return (dispatch, getState) => {

        const { toastTip, ApiPost } = GetParamsData()
        const { enBankName } = GetDepositBankActive()
        const { money } = GetDepositMoneyStatus()
        const methodCode = GetMethodCodeActive() || 'DEFAULT'
        const { bankAccountID } = GetDepositMemberBanksActive() || {}

        let params = `Amount=${money}&PaymentMethodCode=LB&MethodCode=${methodCode}&MemberBankBankAccountID=${bankAccountID}&DepositingBankName=${enBankName}&DepositingBankAcctNum=${data?.accountNo}&BankLogID=${data?.bankLogID}&`
        toastTip.loading('กำลังโหลด…')
        return ApiPost(PayApiPort.InsertMemberDepositStepTwoAccessRecord + params)
            .then((res) => {
                toastTip.hide()
                if (!res || !res.isSuccess) {
                    return
                }
                return res?.isSuccess
            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error("เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือใช้วิธีการฝากเงินอื่น")
            });
    };
}

//添加 LB update member deposit step two complete
export const UpdateMemberDepositStepTwoCompleted = () => {


    return (dispatch, getState) => {

        const { toastTip, ApiPost } = GetParamsData()

        toastTip.loading('กำลังโหลด…')
        return ApiPost(PayApiPort.UpdateMemberDepositStepTwoCompleted + '&')
            .then((res) => {
                toastTip.hide()
                if(res?.isSuccess) {
                    dispatch(SetDepositTimer(''));
                    dispatch(SetDepositMoneyStatus('', '', true));
                    return dispatch(SetDepositNextStep())
                }
                else {
                    toastTip.hide()
                    toastTip.error("เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือใช้วิธีการฝากเงินอื่น")
                }
            })
            .catch((error) => {
                toastTip.hide()
                toastTip.error("เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือใช้วิธีการฝากเงินอื่น")
            });
    };
}

//判断LB step two 進行中
export const GetDepositStepTwoInProgressDetails = methodCode => {
    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        dispatch(SetDepositTimer('')) //reset timer everytime we call to make sure it doesn't carry over wrong timer data
        let params = `paymentMethodCode=${methodCode}&`
        toastTip.loading('กำลังโหลด…')
        return ApiGet(PayApiPort.GetDepositStepTwoInProgressDetails + params)
            .then((res) => {
                toastTip.hide()
                if (res?.isSuccess) {
                    let result = res?.result?.[0]
                    if(result) {
                        let timer = result?.remainingCountdownTime?.substring(result?.remainingCountdownTime.indexOf(':') + 1, result?.remainingCountdownTime.indexOf('.'));
                        dispatch(SetMethodCodeActive(result?.methodType))
                        dispatch(SetDepositAccountByAmount({...result?.bankAccounts, accountNo: result?.bankAccounts?.accountNumber}))
                        dispatch(SetDepositMoneyStatus(result?.methodType == 'NormalAmt' ? result?.amount : result?.convertedAmount))
                        dispatch(SetDepositTimer(timer))
                        dispatch({ type: 'DEPOSIT_PAYMENTS', data: result }) //set deposit payments with get details because transactionId will be all cleared after changing page, unable to cancel transaction
                        return true
                    }
                }
                else if (res?.statusCode === 400) {
                    toastTip.error("เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือใช้วิธีการฝากเงินอื่น")
                    return false
                }
                else {
                    // Handle other non-success cases without showing an error toast
                    return false
                }
            })
            .catch((error) => {
                toastTip.hide()
                // You might want to check the error object here to see if it contains a status code
                if (error?.response?.status === 400) {
                    toastTip.error("เกิดข้อผิดพลาด โปรดลองอีกครั้งหรือใช้วิธีการฝากเงินอื่น")
                }
                return false
            });
    };
}


//清空所有状态,金额，银行，
export const RemoveAllReducers = (data = false) => {
    return (dispatch, getState) => {
        dispatch(SetDepositMoneyStatus('', '', true))
        dispatch(SetDepositOldBankSixNumberStatus('', true))
        dispatch(SetDepositCardNumber_CC('', true))
        dispatch(SetDepositCardPIN_CC('', true))
        dispatch(RemoveUploadFile())
        dispatch(SetDepositNextStep())
        dispatch(SetDepositOldBank())
        dispatch(ClearDepositPayments())

        const action = {
            type: 'REMOVE_ALL_REDUCERS',
            data: data,
        };
        return dispatch(action);
    }

}
// AnnouncementPopup公告
let announcementStorage = { updatedAt: '', }//用时间来判断是否再次显示
export const GetAnnouncementPopup = () => {
    return (dispatch, getState) => {

        let announcement = {}
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(PayApiPort.AnnouncementPopup + 'optionType=Deposit&')
            .then((res) => {
                if (res && res.isSuccess && res.result) {
                    const { updatedAt } = GetStorage('AnnouncementPopup') || {}
                    if(updatedAt != res.result.updatedAt) {
                        //没有缓存设置显示
                        announcement = res.result
                        announcementStorage.updatedAt = res.result.updatedAt
                    }
                }
                const action = { type: 'ANNOUNCEMENT_POPUP', data: announcement }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'ANNOUNCEMENT_POPUP', data: {} }
                return dispatch(action)
            });
    };
}
export const RemoveAnnouncementPopup = () => {
    return (dispatch, getState) => {
        const action = {
            type: 'ANNOUNCEMENT_POPUP',
            data: {},
        };
        return dispatch(action);
    }
}
//获取memberInfo
export const GetMemberInfo = () => {

    return (dispatch, getState) => {

        const { toastTip, ApiGet, goFinishMemberInfo, device } = GetParamsData()
        return ApiGet(PayApiPort.Member)
            .then((res) => {
                if (res && res.isSuccess) {
                    const { memberInfo, memberNewInfo } = res.result || {}
                    const { firstName } = memberInfo || {}
                    const { isLoginOTP } = memberNewInfo || {}
                    if(!firstName) {
                        //添加姓名
                        toastTip.hide()
                        device !== "APP" && goFinishMemberInfo()
                    }else if(isLoginOTP) {
                        //otp
                        toastTip.hide()
                        dispatch(SetLoginOTP(true))
                    } else {
                        //紧急公告弹窗，
                        // dispatch(GetAnnouncementPopup())
                    }
                }
                const action = { type: 'MEMBERINFO', data: res.result.memberInfo || {} }
                return dispatch(action)

            })
            .catch((error) => {
                const action = { type: 'MEMBERINFO', data: {} }
                return dispatch(action)
            });
    };
}
export const SetLoginOTP = (data = false) => {
    return (dispatch, getState) => {
        const action = {
            type: 'LOGIN_OTP',
            data: data,
        };
        return dispatch(action);
    }
}

// 首次充值，获取优惠
export const GetBounsList = ({ depositingWallet, bonusId, bonusRuleGroupId, money }) => {
    return (dispatch, getState) => {
        const { toastTip, ApiGet } = GetParamsData()
        return ApiGet(PayApiPort.Bonus + "transactionType=Deposit&wallet=" + depositingWallet + "&", "GET").then(res => {
            let { isSuccess, result } = res
            let BonusAmount = 0
            let TurnoverAmount = 0
            if (isSuccess && Array.isArray(result) && result.length) {
                let bounsList = result.find(v => v.id == bonusId || v.groupID == bonusRuleGroupId) || {}
                if (Object.keys(bounsList).length) {
                    BonusAmount = Number(money) * bounsList.givingRate > bounsList.maxGiving
                        ? bounsList.maxGiving.toFixed(2)
                        : (Number(money) * bounsList.givingRate).toFixed(2)

                    let bonus = Number(money) * bounsList.givingRate // 紅利

                    if (bonus >= bounsList.maxGiving) {
                        let max = bounsList.maxGiving / bounsList.givingRate
                        TurnoverAmount = ((max + bounsList.maxGiving) * bounsList.releaseValue).toFixed(2)
                    } else {
                        TurnoverAmount = ((Number(money) + bonus) * bounsList.releaseValue).toFixed(2)
                    }
                }
            }
            const action = { type: 'DEPOSIT_BOUNS', data: { BonusAmount, TurnoverAmount } }
            return dispatch(action)
        }).catch((error) => {
            const action = { type: 'DEPOSIT_BOUNS', data: {} }
            return dispatch(action)
        });
    };
}


export const setDepositTriggerFrom = (data) => {
    return (dispatch, getState) => {
        const action = {
            type: 'DEPOSIT_TRIGGER',
            data:data,
        };
        return dispatch(action);
    }
}



















